import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { participants } from 'dataSource/lookup'
import { Form, Popup } from 'devextreme-react'
import httpRequest from 'plugin/httprequest'
import React from 'react'

export class ModalDetailIuranBulanan extends React.Component {
  constructor(props) {
    super(props)

    this.menuName = 'Detail Iuran PPIP'

    this.state = {
      popupVisible: false,
      dataMaster: {},
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.dataGridRef = React.createRef()

    this.dataDetil = []

    this.popupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Tutup',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.formMaster = [
      {
        itemType: 'group',
        items: [
          {
            dataField: 'bulan',
            label: {
              text: 'Periode Bulan',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'tahun',
            label: {
              text: 'Periode Tahun',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'participantId',
            label: {
              text: 'Pemberi Kerja',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: participants(this.props.store),
              valueExpr: 'id',
              displayExpr: 'participantName',
            },
          },
          {
            dataField: 'productName',
            label: {
              text: 'Produk',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
        ],
      },
      {
        itemType: 'group',
      },
    ]

    this.columns = [
      {
        dataField: 'id',
        caption: 'No',
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'full_name',
        caption: 'Nama Peserta',
      },
      {
        dataField: 'phdp',
        caption: 'PHDP',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuran_normal_peserta',
        caption: 'Iuran Peserta',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuran_normal_pk',
        caption: 'Iuran PK',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuran_sukarela_peserta',
        caption: 'Iuran Lain Peserta',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'total_iuran',
        caption: 'Total Iuran',
        format: '#,##0.00',
        alignment: 'right',
      },
    ]
  }

  show = () => {
    this.setState({
      popupVisible: true,
    })
  }

  hide() {
    this.setState({
      popupVisible: false,
      dataMaster: {},
    })
  }

  retrieveData = async (data) => {
    this.setState({ dataMaster: data })
    const response = await httpRequest(
      process.env.REACT_APP_BACKEND_CORE,
      this.props.store,
      `iurans/ppip-iuran-detil/${data.iuranId}`,
      'GET'
    )
    const validDataWithIds = response.map((item, index) => ({
      id: index + 1,
      ...item,
    }))
    this.dataDetil = validDataWithIds
    this.dataGridRef.current.forceRefresh(true)
  }

  loadData = () => {
    return this.dataDetil
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={true}
        showTitle={true}
        title={this.menuName}
        width={'60vw'}
        height={'85vh'}
        ref={this.PopupRef}
        toolbarItems={this.popupToolbarItem}
      >
        <div className="container-fluid">
          <Form
            colCount={2}
            id={'formDetailIuranPpip'}
            formData={this.state.dataMaster}
            items={this.formMaster}
            labelLocation={'left'}
            readOnly={true}
          />
          <div className="mt-3">
            <DevExpressDataGrid
              ref={this.dataGridRef}
              loadAPI={``}
              insertAPI=""
              updateAPI=""
              deleteAPI=""
              keyField="sequence_no"
              backendserver={process.env.REACT_APP_BACKEND_CORE}
              useArraySource={true}
              ArraySourceData={this.loadData}
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
              exportExcel={false}
              exportFileName={this.menuName}
              allowExportSelectedData={true}
              selection={'multiple'}
              showBorders={true}
              paging={true}
              defaultPageSize={10}
              popupTitle={this.menuName}
              popupWidth={700}
              popupHeight={500}
              popupFormLabelLocation="left"
              popupFormMinColWidth={300}
              popupFormColCount={3}
              ColumnChooser={true}
              ColumnFixing={true}
              height={'calc(100vh - 453px)'}
              FilterRow={true}
              ColumnConfiguration={this.columns}
              SummaryConfiguration={this.summary}
              onToolbarPreparing={this.onToolbarPreparing}
              store={this.props.store}
            />
          </div>
        </div>
      </Popup>
    )
  }
}

export default ModalDetailIuranBulanan
